import { documentService } from '../../services';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { APIErrorMessage } from '../../../../../shared/infra/api/APIErrorMessage';
import { FormDocumentRequestDTO } from '../../infra/types';
import { APIResponse } from '../../../../../shared/infra/api/APIResponse';
import { DocumentUtil } from '../../utils/DocumentsUtil';

const createDocumentItem = createAsyncThunk<
  void,
  FormDocumentRequestDTO,
  { rejectValue: APIErrorMessage }
>('documents/createDocumentItems', async (formDocumentRequest, thunkapi) => {
  let result: APIResponse<void>;
  const documentRequest = DocumentUtil.formToRequestDTO(formDocumentRequest);

  if (documentRequest.id) {
    result = await documentService.updateDocumentItem(documentRequest);
  } else {
    result = await documentService.createDocumentItem(documentRequest);
  }

  if (result.isLeft()) {
    const error = result.value;
    return thunkapi.rejectWithValue(error);
  } else {
    return result.value.getValue();
  }
});

export default createDocumentItem;
